import FindKeyDetailModel from './FindKeyDetailModel';
import FindTagDetailModel from './FindTagDetailModel';
import FindKeyDetailModelEditor from './FindKeyDetailModelEditor';
import FindKeyDetailRenderer from './FindKeyDetailRenderer';
import FindTagDetailRenderer from './FindTagDetailRenderer';
import FindKeyAction from './FindKeyAction';
import FindKeyCancelAction from './FindKeyCancelAction';
import FindTagAction from './FindTagAction';
import FindTagCancelAction from './FindTagCancelAction';
const SUPPORTED_OBJECT_TYPES = ['key'];
export default {
  install(molten) {
    molten.addPlugin('Model', {
      type: FindKeyDetailModel.TYPE,
      model: FindKeyDetailModel
    });
    molten.addPlugin('Model', {
      type: FindTagDetailModel.TYPE,
      model: FindTagDetailModel
    });
    molten.addPlugin('ModelEditor', {
      type: FindKeyDetailModel.TYPE,
      editor: FindKeyDetailModelEditor
    });
    molten.addPlugin('ModelEditor', {
      type: FindTagDetailModel.TYPE,
      editor: FindKeyDetailModelEditor
    });
    SUPPORTED_OBJECT_TYPES.forEach(objectType => {
      molten.addPlugin('Detail', {
        name: 'Find Key',
        objectType,
        create: () => FindKeyDetailModel.create(objectType),
        layout: {
          group: []
        }
      });
    });
    molten.addPlugin('Detail', {
      name: 'Find Tag',
      objectType: 'tag',
      create: () => FindTagDetailModel.create('tag'),
      layout: {
        group: []
      }
    });
    molten.addPlugin('DetailRenderer', {
      type: FindKeyDetailModel.TYPE,
      renderer: FindKeyDetailRenderer
    });
    molten.addPlugin('DetailRenderer', {
      type: FindTagDetailModel.TYPE,
      renderer: FindTagDetailRenderer
    });
    molten.addPlugin('Action', FindKeyAction);
    molten.addPlugin('Action', FindKeyCancelAction);
    molten.addPlugin('Action', FindTagAction);
    molten.addPlugin('Action', FindTagCancelAction);
  }
};